import axios from 'axios'

const API_KEY = process.env.REACT_APP_API_KEY

export const global = (city) => {
    const ville = city !== '' ? city : 'Oran'
    const data = axios.get(`https://api.openweathermap.org/data/2.5/weather?q=${ville}&appid=${API_KEY}&lang=fr`).then(res => res.data).catch(err => console.log(err))
    return data
}